import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Logo from '../../img/logo.png'

function Footer() {
    return (
        <Box style={{ height: "64px", width: "100%", zIndex: "1" }} sx={{ flexGrow: 1 }}>
            <AppBar position="static">
                <Toolbar className='footer-Link'>
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                        <img id={'calculogo'} src={Logo} alt={'logo'} />
                    </Typography>
                    <a href={'https://www.aicarbuyer.com/privacy'}> Privacy Policy </a>
                    <a href={'https://www.aicarbuyer.com/terms'} >  Terms & Conditions </a>
                </Toolbar>
            </AppBar>
        </Box>
    )
}

export default Footer;